import React, { useContext, useState } from 'react';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import {
  bool,
  shape,
  string as stringType,
  arrayOf,
  params, useDataModel
} from '@thd-nucleus/data-sources';
import { ServicePro, PushMower, BoxTruck, Store } from '@one-thd/sui-icons';
import { StoreHeroContext } from '../../../StoreHero.context';
import { FeatureBlock } from '../feature-block/FeatureBlock';
import { Layout } from '../Layout';
import { FEATURES_MAP, getRentalService } from './features-list-data';

const FeaturesList = () => {
  const [storeOverlayOpen, setStoreOverlayOpen] = useState(false);

  const { channel } = useContext(ExperienceContext);
  const isMobile = channel === 'mobile';

  const { store } = useContext(StoreHeroContext);
  const { name, storeId } = store || {};

  const storeSearchOptions = {
    variables: {
      pagesize: '1',
      storeSearchInput: storeId
    },
    skip: !storeId
  };
  const {
    data,
    loading
  } = useDataModel('storeSearch', storeSearchOptions);
  const storeServices = data?.storeSearch?.stores?.[0]?.services;
  const showLoader = !data || loading;

  return (
    <div>
      <div>
        <FeatureBlock feature={FEATURES_MAP.home} />
        {showLoader && (
          <div />
        )}
        <FeatureBlock feature={getRentalService(storeServices)} iconEl={<BoxTruck size="large" />} />
        <FeatureBlock feature={FEATURES_MAP.garden} iconEl={<PushMower size="large" />} />
        <FeatureBlock feature={FEATURES_MAP.pro} iconEl={<ServicePro size="large" />} />
        {isMobile && (
          <FeatureBlock
            feature={FEATURES_MAP.storeLayout}
            setStoreOverlayOpen={setStoreOverlayOpen}
            iconEl={<Store size="large" />}
          />
        )}
      </div>
      {storeOverlayOpen && (
        <Layout storeId={storeId} storeName={name} toggleOverlay={setStoreOverlayOpen} />
      )}
    </div>
  );
};

FeaturesList.propTypes = {};

FeaturesList.defaultProps = {};

FeaturesList.displayName = 'FeatureList';

FeaturesList.dataModel = {
  storeSearch: params({ pagesize: stringType().isRequired(), storeSearchInput: stringType().isRequired() }).shape({
    stores: arrayOf(shape({
      services: shape({
        hdMoving: bool(),
        largeEquipment: bool(),
        loadNGo: bool(),
        penske: bool(),
        propane: bool(),
        toolRental: bool(),
        keyCutting: bool(),
        wiFi: bool(),
        applianceShowroom: bool(),
        expandedFlooringShowroom: bool(),
        kitchenShowroom: bool(),
        // toolRentalLite: bool(), //TODO: Need tool RentalLite in the BE.
        // rugDoctor: bool(), //TODO: Need rug doctor in the BE.
      })
    }))
  })
};

export { FeaturesList };
